/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import acquarioGenova from "../../../../images/partner/logo_acquario_genova.png";
import aquafan from "../../../../images/partner/logo_aquafan.png";
import authreChose from "../../../../images/partner/logo_authre_chose.png";
import helbiz from "../../../../images/partner/logo_helbiz.png";
import notoriusCinema from "../../../../images/partner/logo_notorius_cinema_black.png";
import throwback from "../../../../images/partner/logo_throwback.png";
import cway from "../../../../images/partner/logo_cway.png";
import * as s from './css/partner.module.css'
import Button from "../../../../components/button";
import { urls } from "../../../../constants";

// import loreal from "../../../../images/partner/logo_loreal.png";
import nove25 from "../../../../images/partner/logo_nove25.png";
import philips from "../../../../images/partner/logo_philips.png";
import wxi from "../../../../images/partner/logo_wxi.png";

const images = [
  helbiz,
  authreChose,
  throwback,
  acquarioGenova,
  aquafan,
  cway,
  notoriusCinema,
  // philips,
  // nove25,
  // loreal,
  wxi
]

const Partner = ({ project }) => {

  return (
    <>
      <div className="container flex flex-col desktop:mt-p30">

        <div className="text-2 leading-11 mobile:col-span-4 desktop:text-24 desktop:leading-21  font-md text-black text-center" style={{ marginTop:'50px' }}>Alcuni dei Brand partner</div>

        <div className={`${s.imagesContainer}`}>
          {images.map((img, indexImg) => (
            <>
              {(indexImg === images.length - 1) && <div className="flex desktop:hidden"></div>}
              <img src={img} className={`${s.logoPartner}`} style={{ width: '100%', objectFit: 'contain', maxHeight: '45px' }} alt="logo partner" />
            </>
          ))}
        </div>
        <div className={`container-grid`}>
          <div className={`col-span-4 desktop:col-span-4 desktop:col-start-5 ${s.containerButton}`}>
            <div className="text-center mx-4 desktop:mx-0">
              <div>
                <Button id="btnPreorder" className={`${s.btnPreorder} attiva-tinaba-hit-btn`} onClick={() => {
                  window.location.href = urls.ATTIVA_TINABA_HIT;
                }}>
                  Come attivare Tinaba Hit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Partner
